import React from 'react'
import AdminLayout from '../../components/admin/AdminLayout'

const AboutManage = () => {
  return (
    <AdminLayout>
<div>Coming Soon......</div>
    </AdminLayout>
    
  )
}

export default AboutManage